const features = [
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '支持1080P与4K超清画质，每一帧都清晰细腻，带来影院级沉浸式观影体验，不错过任何画面细节。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '秒播不卡顿',
    desc: '全球CDN加速节点覆盖，智能码率自适应技术，无论宽带还是移动网络都能流畅秒播，拒绝缓冲等待。',
  },
  {
    icon: 'ri-global-line',
    title: '海量片库每日更新',
    desc: '收录国产剧、韩剧、港剧、日剧、美剧等5000+剧目，每日同步更新30+剧集，热门新番第一时间上线。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择夫妻影院
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            我们用技术和内容，为你打造最好的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}